<template>
  <div class="mt-6 px-4 flex justify-between items-center w-full">
    <div>
      <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">{{ t('communicationSources.title') }}</h1>
      <h1 class="text text-gray-900 dark:text-gray-200">{{ t('communicationSources.subtitle') }}</h1>
    </div>
    <div class="flex items-center space-x-4 rtl:space-x-reverse">
      <label class="input input-bordered flex items-center" style="width:330px">
        <input type="text" v-model="searchValue" class="grow" :placeholder="t('common.search', 'Search')" />
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="h-4 w-4 opacity-70"><path fill-rule="evenodd" d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" clip-rule="evenodd"/></svg>
      </label>
      <router-link to="/whatsappTemplates" class="btn">
        <Icon icon="mdi:whatsapp" width="18" class="text-green-500" />
        <span>{{ t('communicationSources.whatsappTemplatesButton', 'WhatsApp Templates') }}</span>
      </router-link>
      
      <div class="dropdown dropdown-end">
        <button class="btn" @click="toggleAddDropdown">{{ t('communicationSources.addNewSource') }}</button>
        <ul v-if="showAddDropdown === true" class="menu dropdown-content bg-base-100 rounded-box z-50 w-52 p-2 shadow mt-2">
          <li>
            <button type="button" class="w-full text-left" @click.stop.prevent="chooseType('whatsapp')">Whatsapp</button>
          </li>
          <li>
            <button type="button" class="w-full text-left" @click.stop.prevent="chooseType('phone')">Phone</button>
          </li>
          <li>
            <button type="button" class="w-full text-left" @click.stop.prevent="chooseType('sms')">SMS</button>
          </li>
          <li>
            <button type="button" class="w-full text-left" @click.stop.prevent="chooseType('email')">Email</button>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="mt-6 px-4">
    <ThemeOnly theme="modern" :invert="true">
      <div class="overflow-x-auto text-align card shadow bg-white dark:bg-gray-800 w-full rounded-md p-3 border dark:border-gray-700 flex" style="border-radius: 10px; height: 70vh;">
        <EasyDataTable :headers="headers" :items="items" buttons-pagination :search-field="['type','config.name']" :search-value="searchValue" :loading="loading === true && items.length === 0">
      <template #item-type="item">
        <div class="flex items-center px-2 py-1 icons-row">
          <template v-if="item.type === 'whatsappMeta'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-5 h-5 text-green-500 fill-current"><path d="M20.52 3.48A11.86 11.86 0 0012 0 12 12 0 000 12a11.84 11.84 0 001.64 6L0 24l6.24-1.64A12 12 0 0012 24a12 12 0 008.52-3.48A11.86 11.86 0 0024 12a11.86 11.86 0 00-3.48-8.52zM12 22a9.86 9.86 0 01-5-1.36l-.36-.2-3.72 1 1-3.64-.2-.36A10 10 0 1122 12 9.94 9.94 0 0112 22zm5.52-7.28c-.28-.12-1.64-.8-1.88-.88s-.44-.12-.64.12-.72.88-.88 1.08-.32.2-.6.08a8.27 8.27 0 01-2.44-1.52 9.21 9.21 0 01-1.68-2 .52.52 0 010-.56c.16-.16.36-.4.52-.6s.2-.36.32-.6.08-.44 0-.6-.64-1.56-.88-2.12-.48-.48-.64-.48h-.52a1 1 0 00-.72.36 3 3 0 00-.92 2.2 5.22 5.22 0 001.12 2.76 11.88 11.88 0 004.56 4.28 15.6 15.6 0 001.88.72 4.53 4.53 0 002.08.12 3.06 3.06 0 002-1.36 2.48 2.48 0 00.16-1.36c-.08-.08-.24-.12-.52-.24z"/></svg>
          </template>
          <template v-else-if="item.type === 'whatsapp99Digital'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-5 h-5 text-green-500 fill-current"><path d="M20.52 3.48A11.86 11.86 0 0012 0 12 12 0 000 12a11.84 11.84 0 001.64 6L0 24l6.24-1.64A12 12 0 0012 24a12 12 0 008.52-3.48A11.86 11.86 0 0024 12a11.86 11.86 0 00-3.48-8.52zM12 22a9.86 9.86 0 01-5-1.36l-.36-.2-3.72 1 1-3.64-.2-.36A10 10 0 1122 12 9.94 9.94 0 0112 22zm5.52-7.28c-.28-.12-1.64-.8-1.88-.88s-.44-.12-.64.12-.72.88-.88 1.08-.32.2-.6.08a8.27 8.27 0 01-2.44-1.52 9.21 9.21 0 01-1.68-2 .52.52 0 010-.56c.16-.16.36-.4.52-.6s.2-.36.32-.6.08-.44 0-.6-.64-1.56-.88-2.12-.48-.48-.64-.48h-.52a1 1 0 00-.72.36 3 3 0 00-.92 2.2 5.22 5.22 0 001.12 2.76 11.88 11.88 0 004.56 4.28 15.6 15.6 0 001.88.72 4.53 4.53 0 002.08.12 3.06 3.06 0 002-1.36 2.48 2.48 0 00.16-1.36c-.08-.08-.24-.12-.52-.24z"/></svg>
          </template>
          <template v-else-if="item.type === 'whatsappSmooch'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-5 h-5 text-green-500 fill-current"><path d="M20.52 3.48A11.86 11.86 0 0012 0 12 12 0 000 12a11.84 11.84 0 001.64 6L0 24l6.24-1.64A12 12 0 0012 24a12 12 0 008.52-3.48A11.86 11.86 0 0024 12a11.86 11.86 0 00-3.48-8.52zM12 22a9.86 9.86 0 01-5-1.36l-.36-.2-3.72 1 1-3.64-.2-.36A10 10 0 1122 12 9.94 9.94 0 0112 22zm5.52-7.28c-.28-.12-1.64-.8-1.88-.88s-.44-.12-.64.12-.72.88-.88 1.08-.32.2-.6.08a8.27 8.27 0 01-2.44-1.52 9.21 9.21 0 01-1.68-2 .52.52 0 010-.56c.16-.16.36-.4.52-.6s.2-.36.32-.6.08-.44 0-.6-.64-1.56-.88-2.12-.48-.48-.64-.48h-.52a1 1 0 00-.72.36 3 3 0 00-.92 2.2 5.22 5.22 0 001.12 2.76 11.88 11.88 0 004.56 4.28 15.6 15.6 0 001.88.72 4.53 4.53 0 002.08.12 3.06 3.06 0 002-1.36 2.48 2.48 0 00.16-1.36c-.08-.08-.24-.12-.52-.24z"/></svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 26 26"><path fill="#020406" d="M12 8.2v14.5H0zM12 3c0 3.3-2.7 6-6 6S0 6.3 0 3zm2 19.7c0-3.3 2.7-6 6-6s6 2.7 6 6zm0-5.2V3h12z"/></svg>
          </template>
          <template v-else-if="item.type === 'twilioPhone' || item.type === 'phonePartner' || item.type === 'phoneCustomSip'">
            <Icon icon="tabler:phone" width="18" />
          </template>
          <template v-else-if="['smsTwilio', 'smsMaskyoo', 'smsQuota'].includes(item.type) === true">
            <Icon icon="tabler:message" width="18" />
          </template>
          <template v-else-if="item.type === 'emailMicrosoft365' || item.type === 'emailGoogleGmail'">
            <Icon icon="tabler:mail" width="18" />
          </template>
          <span class="pl-1">{{ getTypeDisplay(item.type) }}</span>
        </div>
        <div v-if="getMetaCustomDomainDisplay(item) !== ''" class="px-2 pb-1 text-xs text-base-content/60 font-mono truncate max-w-xs">
          {{ getMetaCustomDomainDisplay(item) }}
        </div>
      </template>
      
      <template #item-options="item">
        <div class="flex items-center space-x-3 rtl:space-x-reverse">
          <button v-if="isEmailSource(item) === true" type="button" @click="openTestEmailModal(item)" :class="editButtonClass">test</button>
          <button v-if="isWhatsappVoiceSource(item) === true" type="button" @click="openWhatsappVoiceSetupModal(item)" class="btn btn-sm">Voice setup</button>
          <button type="button" @click="edit(item)" :class="getEditButtonClass(item)" :disabled="isPartnerPhone(item) === true">{{ t('common.edit') }}</button>
          <button type="button" @click="requestRemove(item)" :class="getDeleteButtonClass(item)" :disabled="isPartnerPhone(item) === true">{{ t('common.delete') }}</button>
        </div>
      </template>
      <template #loading>
        <ModernLoader />
      </template>
    </EasyDataTable>
      </div>
    </ThemeOnly>

    <ThemeOnly theme="modern">
      <ModernAgentTable 
        :headers="headers" 
        :items="items" 
        :loading="loading === true"
      >
        <template #item-type="{ item }">
          <div class="flex items-center space-x-2">
            <span class="type-pill type-public uppercase text-[10px]">{{ getTypeDisplay(item.type) }}</span>
          </div>
          <div v-if="getMetaCustomDomainDisplay(item) !== ''" class="text-xs text-base-content/60 font-mono truncate max-w-xs mt-1">
            {{ getMetaCustomDomainDisplay(item) }}
          </div>
        </template>
        <template #item-createdAt="{ item }">{{ formatDate(item.createdAt) }}</template>
        <template #item-updatedAt="{ item }">{{ formatDate(item.updatedAt) }}</template>
        <template #item-options="{ item }">
          <div class="flex items-center justify-end space-x-3 rtl:space-x-reverse">
            <button v-if="isEmailSource(item) === true" type="button" @click="openTestEmailModal(item)" class="action-btn">
              <Icon icon="tabler:send" width="16" />
              <span class="btn-text">test</span>
            </button>
            <button v-if="isWhatsappVoiceSource(item) === true" type="button" @click="openWhatsappVoiceSetupModal(item)" class="btn btn-sm">
              <Icon icon="tabler:phone-check" width="16" />
              <span>Voice setup</span>
            </button>
            <button type="button" @click="edit(item)" class="action-btn" :class="{ 'action-btn-disabled': isPartnerPhone(item) === true }" :disabled="isPartnerPhone(item) === true">
              <Icon icon="tabler:edit" width="16" />
              <span class="btn-text">{{ t('common.edit') }}</span>
            </button>
            <button type="button" @click="requestRemove(item)" class="action-btn btn-delete" :class="{ 'action-btn-disabled': isPartnerPhone(item) === true }" :disabled="isPartnerPhone(item) === true">
              <Icon icon="tabler:trash" width="16" />
              <span class="btn-text">{{ t('common.delete') }}</span>
            </button>
          </div>
        </template>
      </ModernAgentTable>
    </ThemeOnly>
  </div>

  <CommunicationSourceProviderModal
    :visible="showModal"
    :type="current.type"
    :model="current.config"
    :isEdit="isEdit"
    :source-id="current.sourceId"
    @close="closeModal"
    @save="onModalSave"
    @attachWebhook="attachDigital99Webhook"
  />

  <div class="modal" :class="{ 'modal-open': showPostCreateModal === true }">
    <div class="modal-box w-11/12 max-w-xl">
      <h3 class="font-bold text-lg mb-4">{{ postCreateModalTitle }}</h3>
      
      <div class="mt-4">
        <label class="label"><span class="label-text" dir="ltr">{{ postCreateModalHint }}</span></label>
        <div class="flex items-center force-ltr" dir="ltr">
          <input dir="ltr" class="input input-bordered w-full force-ltr" :value="toLtr(postCreateWebhookWithAgent)" readonly />
          <button type="button" class="btn btn-sm ml-2" @click="handlePostCopy('agent', postCreateWebhookWithAgent)">{{ copiedPostKey === 'agent' ? t('common.copied','Copied') : t('deployModal.copy','Copy') }}</button>
        </div>
      </div>
      <div class="modal-action">
        <button class="btn" @click="showPostCreateModal = false">{{ t('deployModal.close','Close') }}</button>
      </div>
    </div>
    <form method="dialog" class="modal-backdrop"><button @click="showPostCreateModal = false">close</button></form>
  </div>

  <div class="modal" :class="{ 'modal-open': showDeleteConfirmModal === true }">
    <div class="modal-box max-w-md">
      <h3 class="font-bold text-lg">{{ t('communicationSources.deleteConfirmTitle') }}</h3>
      <p class="py-4">{{ t('communicationSources.deleteConfirmBody', { name: deleteTargetLabel }) }}</p>
      <div class="modal-action">
        <button type="button" class="btn" @click="closeDeleteConfirmModal" :disabled="deleteInProgress === true">{{ t('common.cancel') }}</button>
        <button type="button" class="btn btn-error" @click="confirmRemove" :disabled="deleteInProgress === true">{{ t('common.delete') }}</button>
      </div>
    </div>
    <form method="dialog" class="modal-backdrop"><button type="button" @click="closeDeleteConfirmModal">close</button></form>
  </div>

  <div class="modal" :class="{ 'modal-open': showTestEmailModal === true }">
    <div class="modal-box max-w-2xl">
      <h3 class="font-bold text-lg">Test Email Source</h3>
      <p class="py-2">{{ getItemName(testEmailSource) }}</p>
      <div>
        <label class="label"><span class="label-text">Title</span></label>
        <input type="text" v-model="testEmailForm.title" class="input input-bordered w-full" />
      </div>
      <div class="mt-3">
        <label class="label"><span class="label-text">Email Body</span></label>
        <textarea v-model="testEmailForm.body" class="textarea textarea-bordered w-full min-h-40"></textarea>
      </div>
      <div class="mt-3">
        <label class="label"><span class="label-text">Addresses</span></label>
        <textarea v-model="testEmailForm.addresses" class="textarea textarea-bordered w-full min-h-28" placeholder="email1@example.com, email2@example.com"></textarea>
      </div>
      <div class="modal-action">
        <button type="button" class="btn" @click="closeTestEmailModal" :disabled="sendingTestEmail === true">Cancel</button>
        <button type="button" class="btn" @click="sendTestEmail" :disabled="canSendTestEmail === false">{{ sendingTestEmail === true ? 'Sending...' : 'Send' }}</button>
      </div>
    </div>
    <form method="dialog" class="modal-backdrop"><button type="button" @click="closeTestEmailModal">close</button></form>
  </div>

  <div class="modal" :class="{ 'modal-open': showWhatsappVoiceSetupModal === true }">
    <div class="modal-box w-11/12 max-w-4xl">
      <div class="flex items-center justify-between mb-4">
        <div>
          <span class="text-xs uppercase font-bold tracking-wider text-green-600 dark:text-green-400">Meta WhatsApp Voice Setup</span>
          <h3 class="font-bold text-xl text-gray-900 dark:text-gray-100">Step-by-step Meta Approval</h3>
          <p class="text-xs text-base-content/70 mt-1">
            Complete the required Meta API requests and webhook subscription for <span class="font-semibold">{{ getItemName(whatsappVoiceSetupSource) }}</span> ({{ getPhoneNumber(whatsappVoiceSetupSource) }}).
          </p>
        </div>
        <button type="button" class="btn btn-sm" @click="closeWhatsappVoiceSetupModal">✕</button>
      </div>

      <div class="flex flex-col md:flex-row mt-4">
        <div class="w-full md:w-64 mb-4 md:mb-0 md:mr-6">
          <div class="numbered-actions">
            <button
              type="button"
              class="numbered-action-item"
              :class="{ 'active-step': whatsappVoiceSetupActiveStep === 1, 'ready-step': true }"
              @click="whatsappVoiceSetupActiveStep = 1"
            >
              <span class="numbered-action-badge">1</span>
              <div class="numbered-action-text">
                <strong>Credentials</strong>
                <small>WABA & Phone IDs saved</small>
              </div>
            </button>

            <button
              type="button"
              class="numbered-action-item"
              :class="{ 'active-step': whatsappVoiceSetupActiveStep === 2, 'ready-step': whatsappVoiceSetupAppSubscribed === true }"
              @click="whatsappVoiceSetupActiveStep = 2"
            >
              <span class="numbered-action-badge">2</span>
              <div class="numbered-action-text">
                <strong>Subscribe WABA</strong>
                <small>Meta App subscription</small>
              </div>
            </button>

            <button
              type="button"
              class="numbered-action-item"
              :class="{ 'active-step': whatsappVoiceSetupActiveStep === 3, 'ready-step': whatsappVoiceSetupWebhookSubscribed === true }"
              @click="whatsappVoiceSetupActiveStep = 3"
            >
              <span class="numbered-action-badge">3</span>
              <div class="numbered-action-text">
                <strong>Set callback</strong>
                <small>Voice webhook callback</small>
              </div>
            </button>

            <button
              type="button"
              class="numbered-action-item"
              :class="{ 'active-step': whatsappVoiceSetupActiveStep === 4, 'ready-step': whatsappVoiceSetupCallingSaved === true }"
              @click="whatsappVoiceSetupActiveStep = 4"
            >
              <span class="numbered-action-badge">4</span>
              <div class="numbered-action-text">
                <strong>Calling API</strong>
                <small>Status & codecs</small>
              </div>
            </button>

            <button
              type="button"
              class="numbered-action-item"
              :class="{ 'active-step': whatsappVoiceSetupActiveStep === 5, 'ready-step': whatsappVoiceSetupPermissionSent === true }"
              @click="whatsappVoiceSetupActiveStep = 5"
            >
              <span class="numbered-action-badge">5</span>
              <div class="numbered-action-text">
                <strong>Call permission</strong>
                <small>Ask contact to allow calls</small>
              </div>
            </button>
          </div>
        </div>

        <div class="flex-1 border dark:border-gray-700 rounded-lg p-4 bg-base-100">
          <div v-if="whatsappVoiceSetupActiveStep === 1">
            <span class="text-xs uppercase font-bold text-base-content/60">Step 1 · WhatsApp Voice Account</span>
            <h4 class="font-bold text-lg text-gray-900 dark:text-gray-100 mt-1">Meta credentials saved</h4>
            <p class="text-xs text-base-content/70 mt-1">Credentials used for Meta Calling API and WABA webhooks.</p>
            <div class="mt-4 p-3 rounded-lg bg-base-200 text-xs">
              <div class="flex justify-between py-1">
                <span class="text-base-content/70">Display name:</span>
                <span class="font-mono font-medium">{{ getItemName(whatsappVoiceSetupSource) }}</span>
              </div>
              <div class="flex justify-between py-1">
                <span class="text-base-content/70">Phone number:</span>
                <span class="font-mono font-medium">{{ getPhoneNumber(whatsappVoiceSetupSource) }}</span>
              </div>
              <div class="flex justify-between py-1">
                <span class="text-base-content/70">Phone Number ID:</span>
                <span class="font-mono font-medium">{{ getPhoneNumberId(whatsappVoiceSetupSource) }}</span>
              </div>
              <div class="flex justify-between py-1">
                <span class="text-base-content/70">WABA ID:</span>
                <span class="font-mono font-medium">{{ getWabaId(whatsappVoiceSetupSource) }}</span>
              </div>
            </div>
            <div class="mt-6 flex justify-end">
              <button type="button" class="btn btn-sm" @click="whatsappVoiceSetupActiveStep = 2">Next: Subscribe WABA →</button>
            </div>
          </div>

          <div v-if="whatsappVoiceSetupActiveStep === 2">
            <span class="text-xs uppercase font-bold text-base-content/60">Step 2 · WABA subscription</span>
            <h4 class="font-bold text-lg text-gray-900 dark:text-gray-100 mt-1">Subscribe Meta app to WABA</h4>
            <p class="text-xs text-base-content/70 mt-1">
              Subscribes your Meta App to WABA events. It will not add, replace, or remove any callback URL.
            </p>
            <div class="mt-4">
              <button
                type="button"
                class="btn btn-sm"
                @click="subscribeWhatsappVoiceApp"
                :disabled="whatsappVoiceSetupSubscribingApp === true"
              >
                {{ whatsappVoiceSetupSubscribingApp === true ? 'Subscribing…' : (whatsappVoiceSetupAppSubscribed === true ? 'Subscribed ✓' : 'Subscribe WABA') }}
              </button>
            </div>
            <div v-if="whatsappVoiceSetupAppSubscribed === true" class="setup-checklist-box mt-4">
              <strong class="text-xs text-green-600 dark:text-green-400">Meta app subscribed</strong>
              <p class="text-xs text-base-content/70 mt-1">The app is now subscribed to this WABA. Complete the steps below in Meta:</p>
              <div class="mt-3">
                <div class="setup-checklist-step">
                  <span class="setup-step-num">1</span>
                  <span>Enable the <strong>calls</strong> and <strong>messages</strong> fields once in Meta App Dashboard.</span>
                </div>
                <div class="setup-checklist-step">
                  <span class="setup-step-num">2</span>
                  <span>Use step 3 to configure the server webhook callback.</span>
                </div>
                <div class="setup-checklist-step">
                  <span class="setup-step-num">3</span>
                  <span>Obtain call permission from the WhatsApp user.</span>
                </div>
              </div>
              <div class="mt-3 flex items-center">
                <a class="btn btn-sm" href="https://developers.facebook.com/apps/" target="_blank" rel="noopener noreferrer">Open Meta Dashboard</a>
                <button type="button" class="btn btn-sm ml-2" @click="whatsappVoiceSetupActiveStep = 3">Next: Set callback →</button>
              </div>
            </div>
          </div>

          <div v-if="whatsappVoiceSetupActiveStep === 3">
            <span class="text-xs uppercase font-bold text-base-content/60">Step 3 · Webhook callback</span>
            <h4 class="font-bold text-lg text-gray-900 dark:text-gray-100 mt-1">Configure the callback in Meta</h4>
            <p class="text-xs text-base-content/70 mt-1">
              Copy the callback URL below into Meta Developer Dashboard. The custom domains are not webhook hosts.
            </p>
            <div class="mt-3">
              <label class="label"><span class="label-text text-xs">Voice service URL</span></label>
              <input type="text" :value="whatsappVoiceSetupServiceUrl" readonly class="input input-bordered w-full text-xs font-mono" />
            </div>
            <div class="mt-3">
              <label class="label"><span class="label-text text-xs">Webhook callback URL to provide Meta</span></label>
              <div class="flex items-center">
                <input type="text" v-model="whatsappVoiceSetupCallbackUrl" readonly class="input input-bordered w-full text-xs font-mono" />
                <button type="button" class="btn btn-sm ml-2" @click="copyWhatsappVoiceWebhook">Copy</button>
              </div>
            </div>
            <div class="setup-checklist-box mt-4">
              <strong class="text-xs text-green-600 dark:text-green-400">Complete this in Meta Dashboard</strong>
              <p class="text-xs text-base-content/70 mt-1">Use the displayed webhook URL exactly as shown:</p>
              <div class="mt-3">
                <div class="setup-checklist-step">
                  <span class="setup-step-num">1</span>
                  <span>Open your Meta app in Meta Developer Dashboard.</span>
                </div>
                <div class="setup-checklist-step">
                  <span class="setup-step-num">2</span>
                  <span>Go to WhatsApp → Configuration → Webhooks.</span>
                </div>
                <div class="setup-checklist-step">
                  <span class="setup-step-num">3</span>
                  <span>Set the callback URL above and subscribe to the <strong>calls</strong> field.</span>
                </div>
              </div>
              <div class="mt-3 flex items-center">
                <a class="btn btn-sm" href="https://developers.facebook.com/apps/" target="_blank" rel="noopener noreferrer">Open Meta Dashboard</a>
                <button type="button" class="btn btn-sm ml-2" @click="whatsappVoiceSetupActiveStep = 4">Next: Calling settings →</button>
              </div>
            </div>
          </div>

          <div v-if="whatsappVoiceSetupActiveStep === 4">
            <span class="text-xs uppercase font-bold text-base-content/60">Step 4 · Meta Calling API</span>
            <h4 class="font-bold text-lg text-gray-900 dark:text-gray-100 mt-1">Voice calling settings in Meta</h4>
            <p class="text-xs text-base-content/70 mt-1">
              Configures Meta Calling API with status ENABLED, PCMU codec, and callback permissions.
            </p>
            <div class="mt-3">
              <label class="label"><span class="label-text text-xs">Call button visibility</span></label>
              <select v-model="whatsappVoiceSetupCallingForm.voiceCallIconVisibility" class="select select-bordered w-full text-xs">
                <option value="default">Show call button</option>
                <option value="disableAll">Hide unsolicited call entry points</option>
              </select>
            </div>
            <div class="mt-3">
              <label class="label cursor-pointer justify-start">
                <input type="checkbox" v-model="whatsappVoiceSetupCallingForm.voiceCallbackPermissionEnabled" class="checkbox" />
                <span class="label-text text-xs ml-2">Request callback permission after inbound calls</span>
              </label>
            </div>
            <div class="mt-4">
              <button
                type="button"
                class="btn btn-sm"
                @click="saveWhatsappVoiceCallingSettings"
                :disabled="whatsappVoiceSetupSavingCalling === true"
              >
                {{ whatsappVoiceSetupSavingCalling === true ? 'Applying…' : (whatsappVoiceSetupCallingSaved === true ? 'Settings applied ✓' : 'Apply calling settings') }}
              </button>
            </div>
            <div v-if="whatsappVoiceSetupCallingSaved === true" class="setup-checklist-box mt-4">
              <strong class="text-xs text-green-600 dark:text-green-400">Meta Calling status ENABLED</strong>
              <p class="text-xs text-base-content/70 mt-1">Meta accepted the calling configuration. Audio codecs PCMU are active.</p>
              <div class="mt-3">
                <button type="button" class="btn btn-sm" @click="whatsappVoiceSetupActiveStep = 5">Next: Request permission →</button>
              </div>
            </div>
          </div>

          <div v-if="whatsappVoiceSetupActiveStep === 5">
            <span class="text-xs uppercase font-bold text-base-content/60">Step 5 · Call permission</span>
            <h4 class="font-bold text-lg text-gray-900 dark:text-gray-100 mt-1">Request permission to call</h4>
            <p class="text-xs text-base-content/70 mt-1">
              Send an interactive WhatsApp message that lets a contact approve temporary or permanent calls from your business.
            </p>
            <template v-if="whatsappVoiceSetupPermissionSent !== true">
              <div class="mt-3">
                <label class="label"><span class="label-text text-xs">WhatsApp phone number</span></label>
                <input type="tel" v-model="whatsappVoiceSetupPermissionForm.recipient" class="input input-bordered w-full text-xs" placeholder="+14155550132" />
              </div>
              <div class="mt-3">
                <label class="label"><span class="label-text text-xs">Reason for the call</span></label>
                <textarea v-model="whatsappVoiceSetupPermissionForm.message" class="textarea textarea-bordered w-full text-xs min-h-24" maxlength="1024"></textarea>
              </div>
              <div class="mt-2 rounded-lg bg-base-200 p-2 text-xs">
                Free-form requests work during Meta's customer-service window. Outside that window, use an approved call-permission message template in Meta.
              </div>
              <div class="mt-4">
                <button
                  type="button"
                  class="btn btn-sm"
                  @click="sendWhatsappVoicePermissionRequest"
                  :disabled="whatsappVoiceSetupSendingPermission === true"
                >
                  {{ whatsappVoiceSetupSendingPermission === true ? 'Sending…' : 'Send permission request' }}
                </button>
              </div>
            </template>
            <template v-else>
              <div class="setup-checklist-box mt-4">
                <strong class="text-xs text-green-600 dark:text-green-400">Waiting for contact approval</strong>
                <p class="text-xs text-base-content/70 mt-1">Meta accepted the permission message. The contact must approve it in WhatsApp before the agent can call.</p>
                <div v-if="whatsappVoiceSetupPermissionMessageId !== ''" class="mt-2 p-2 rounded bg-base-200 text-xs font-mono break-all">
                  Message ID: {{ whatsappVoiceSetupPermissionMessageId }}
                </div>
                <div class="mt-3">
                  <div class="setup-checklist-step">
                    <span class="setup-step-num">1</span>
                    <span>Contact opens WhatsApp and views the call permission card.</span>
                  </div>
                  <div class="setup-checklist-step">
                    <span class="setup-step-num">2</span>
                    <span>Contact grants permission (temporary or permanent calls).</span>
                  </div>
                  <div class="setup-checklist-step">
                    <span class="setup-step-num">3</span>
                    <span>Contact is approved for calls!</span>
                  </div>
                </div>
              </div>
            </template>
            <div class="mt-4 pt-3 border-t border-base-300">
              <span class="text-xs uppercase font-bold text-base-content/60">Outbound Call Permission Template</span>
              <p class="text-xs text-base-content/70 mt-1">
                Create a Meta-approved template to request call permission relative to language for use in Quick Outbound.
              </p>
              <div class="mt-2">
                <label class="label py-1"><span class="label-text text-xs">Template Language</span></label>
                <select v-model="whatsappVoiceSetupTemplateLanguage" class="select select-bordered select-sm w-full text-xs" @change="handleVoiceSetupTemplateLanguageChange">
                  <option v-for="opt in callPermissionLanguageOptions" :key="opt.code" :value="opt.code">
                    {{ opt.label }}
                  </option>
                </select>
              </div>
              <div class="mt-2">
                <label class="label py-1"><span class="label-text text-xs">Template Name</span></label>
                <input type="text" v-model="whatsappVoiceSetupTemplateName" class="input input-bordered input-sm w-full font-mono text-xs" />
              </div>
              <div class="mt-2">
                <label class="label py-1"><span class="label-text text-xs">Template Body</span></label>
                <textarea v-model="whatsappVoiceSetupTemplateBody" class="textarea textarea-bordered textarea-sm w-full text-xs" rows="2"></textarea>
              </div>
              <div class="mt-3 flex items-center">
                <button
                  type="button"
                  class="btn btn-sm"
                  @click="createVoiceSetupCallPermissionTemplate"
                  :disabled="whatsappVoiceSetupCreatingTemplate === true"
                >
                  {{ whatsappVoiceSetupCreatingTemplate === true ? 'Creating…' : 'Create Template in Meta' }}
                </button>
                <span v-if="whatsappVoiceSetupTemplateCreated === true" class="text-xs text-green-600 ml-2 font-medium">✓ Template created</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-action mt-6">
        <button type="button" class="btn" @click="closeWhatsappVoiceSetupModal">Close</button>
      </div>
    </div>
    <form method="dialog" class="modal-backdrop"><button type="button" @click="closeWhatsappVoiceSetupModal">close</button></form>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import axios from '../api/axiosInstance';
import EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import { globalState } from '@/globalState';
import ModernLoader from '@/components/ModernLoader.vue';
import CommunicationSourceProviderModal from '@/components/CommunicationSourceProviderModal.vue';
import ThemeOnly from '@/components/ThemeOnly.vue';
import ModernAgentTable from '@/components/ModernAgentTable.vue';
import { Icon } from '@iconify/vue';
import { useToast } from 'vue-toastification';
import { useI18n } from '@/i18n.js';

const searchValue = ref('');
const items = ref([]);
const loading = ref(false);
const showAddDropdown = ref(false);
const showModal = ref(false);
const isEdit = ref(false);
const current = ref({ type: '', config: { name: '' } });
const toast = useToast();
const { t, currentLanguage } = useI18n();

const showPostCreateModal = ref(false);
const postCreateModalTitle = ref('');
const postCreateModalHint = ref('');
const postCreateWebhook = ref('');
const postCreateWebhookWithAgent = ref('');
const copiedPostKey = ref('');
const showDeleteConfirmModal = ref(false);
const pendingDeleteItem = ref(null);
const deleteInProgress = ref(false);
const showTestEmailModal = ref(false);
const testEmailSource = ref(null);
const sendingTestEmail = ref(false);
const testEmailForm = ref(createDefaultTestEmailForm());
const showWhatsappVoiceSetupModal = ref(false);
const whatsappVoiceSetupSource = ref(null);
const whatsappVoiceSetupActiveStep = ref(1);
const whatsappVoiceSetupAppSubscribed = ref(false);
const whatsappVoiceSetupWebhookSubscribed = ref(false);
const whatsappVoiceSetupCallingSaved = ref(false);
const whatsappVoiceSetupPermissionSent = ref(false);
const whatsappVoiceSetupPermissionMessageId = ref('');
const whatsappVoiceSetupSubscribingApp = ref(false);
const whatsappVoiceSetupSubscribingWebhook = ref(false);
const whatsappVoiceSetupSavingCalling = ref(false);
const whatsappVoiceSetupSendingPermission = ref(false);
const whatsappVoiceSetupServiceUrl = ref('');
const whatsappVoiceSetupCallbackUrl = ref('');
const whatsappVoiceSetupCallingForm = ref({
  voiceCallIconVisibility: 'default',
  voiceCallbackPermissionEnabled: true
});
const whatsappVoiceSetupPermissionForm = ref({
  recipient: '',
  message: 'We would like to call you to help with your request. Please allow us to call you on WhatsApp.'
});

const whatsappVoiceSetupTemplateLanguage = ref('he');
const whatsappVoiceSetupTemplateName = ref('callpermissionrequesthe');
const whatsappVoiceSetupTemplateBody = ref('שלום, אנו מבקשים את אישורך לקבלת שיחה טלפונית בוואטסאפ מנציגנו.');
const whatsappVoiceSetupCreatingTemplate = ref(false);
const whatsappVoiceSetupTemplateCreated = ref(false);

const callPermissionLanguageOptions = [
  { code: 'he', label: 'עברית (Hebrew)' },
  { code: 'en_US', label: 'English (US)' },
  { code: 'en_GB', label: 'English (UK)' },
  { code: 'ar', label: 'العربية (Arabic)' },
  { code: 'es', label: 'Español (Spanish)' },
  { code: 'ru', label: 'Русский (Russian)' },
  { code: 'fr', label: 'Français (French)' }
];

const callPermissionLanguagePresets = {
  he: {
    code: 'he',
    name: 'callpermissionrequesthe',
    body: 'שלום, אנו מבקשים את אישורך לקבלת שיחה טלפונית בוואטסאפ מנציגנו.'
  },
  en_US: {
    code: 'en_US',
    name: 'callpermissionrequesten',
    body: 'Hello, we would like to request your permission to call you on WhatsApp.'
  },
  en_GB: {
    code: 'en_GB',
    name: 'callpermissionrequestengb',
    body: 'Hello, we would like to request your permission to call you on WhatsApp.'
  },
  ar: {
    code: 'ar',
    name: 'callpermissionrequestar',
    body: 'مرحباً، نطلب موافقتك لتلقي مكالمة هاتفية عبر واتساب.'
  },
  es: {
    code: 'es',
    name: 'callpermissionrequestes',
    body: 'Hola, solicitamos su permiso para comunicarnos mediante una llamada de voz en WhatsApp.'
  },
  ru: {
    code: 'ru',
    name: 'callpermissionrequestru',
    body: 'Здравствуйте, мы запрашиваем ваше разрешение на голосовой звонок в WhatsApp.'
  },
  fr: {
    code: 'fr',
    name: 'callpermissionrequestfr',
    body: 'Bonjour, nous souhaitons solliciter votre autorisation pour vous contacter par appel WhatsApp.'
  }
};

function resolveDefaultCallPermissionLanguage() {
  const lang = typeof currentLanguage.value === 'string' ? currentLanguage.value.toLowerCase() : '';
  if (lang === 'he') {
    return 'he';
  }
  if (lang === 'il') {
    return 'he';
  }
  if (lang === 'ar') {
    return 'ar';
  }
  if (lang === 'es') {
    return 'es';
  }
  if (lang === 'ru') {
    return 'ru';
  }
  if (lang === 'fr') {
    return 'fr';
  }
  return 'en_US';
}

function handleVoiceSetupTemplateLanguageChange() {
  const selectedLang = whatsappVoiceSetupTemplateLanguage.value;
  const preset = callPermissionLanguagePresets[selectedLang];
  if (preset !== undefined) {
    if (preset !== null) {
      whatsappVoiceSetupTemplateName.value = preset.name;
      whatsappVoiceSetupTemplateBody.value = preset.body;
    }
  }
}

async function createVoiceSetupCallPermissionTemplate() {
  const item = whatsappVoiceSetupSource.value;
  if (item === undefined) {
    return;
  }
  if (item === null) {
    return;
  }
  const sourceId = item.sourceId;
  whatsappVoiceSetupCreatingTemplate.value = true;
  whatsappVoiceSetupTemplateCreated.value = false;
  try {
    await axios.post(`${globalState.apiEndpoint}/api/communicationSources/whatsappMeta/${sourceId}/callPermissionTemplate`, {
      languageCode: whatsappVoiceSetupTemplateLanguage.value,
      templateName: whatsappVoiceSetupTemplateName.value,
      bodyText: whatsappVoiceSetupTemplateBody.value
    });
    whatsappVoiceSetupCreatingTemplate.value = false;
    whatsappVoiceSetupTemplateCreated.value = true;
    toast.success('Call permission template created successfully in Meta.');
  } catch (error) {
    whatsappVoiceSetupCreatingTemplate.value = false;
    let errorMsg = 'Failed to create call permission template in Meta.';
    if (error?.response?.data?.details !== undefined) {
      if (typeof error.response.data.details === 'string') {
        if (error.response.data.details.length > 0) {
          errorMsg = error.response.data.details;
        }
      }
    }
    toast.error(errorMsg);
  }
}

const editButtonClass = 'hover:text-red-900 p-3 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500';
const deleteButtonClass = 'hover:text-red-900 p-3 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500';
const lockedButtonClass = 'p-3 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-400 bg-gray-100 cursor-not-allowed opacity-70';

const deleteTargetLabel = computed(() => {
  const item = pendingDeleteItem.value;
  return getItemName(item);
});

const canSendTestEmail = computed(() => {
  if (sendingTestEmail.value === true) {
    return false;
  }
  const source = testEmailSource.value !== undefined && testEmailSource.value !== null;
  if (source === false) {
    return false;
  }
  const formValue = testEmailForm.value !== undefined && testEmailForm.value !== null ? testEmailForm.value : {};
  const title = typeof formValue.title === 'string' ? formValue.title.trim() : '';
  const body = typeof formValue.body === 'string' ? formValue.body.trim() : '';
  const addresses = typeof formValue.addresses === 'string' ? formValue.addresses.trim() : '';
  return title.length > 0 && body.length > 0 && addresses.length > 0;
});

const canSendWhatsappVoicePermission = computed(() => {
  if (whatsappVoiceSetupSendingPermission.value === true) {
    return false;
  }
  const source = whatsappVoiceSetupSource.value;
  if (source === undefined || source === null) {
    return false;
  }
  const recipient = normalizeE164(whatsappVoiceSetupPermissionForm.value.recipient);
  const message = typeof whatsappVoiceSetupPermissionForm.value.message === 'string' ? whatsappVoiceSetupPermissionForm.value.message.trim() : '';
  return recipient !== '' && message.length > 0 && message.length <= 1024;
});

const headers = computed(() => [
  { text: t('communicationSources.headers.id'), value: 'sourceId', sortable: true },
  { text: t('communicationSources.headers.type'), value: 'type', sortable: true },
  { text: t('communicationSources.headers.name'), value: 'config.name', sortable: false },
  { text: t('communicationSources.headers.phone'), value: 'phoneDisplay', sortable: false },
  { text: t('communicationSources.headers.created'), value: 'createdAt', sortable: true },
  { text: t('communicationSources.headers.updated'), value: 'updatedAt', sortable: true },
  { text: t('communicationSources.headers.options'), value: 'options' }
]);

function safeName(n) {
  if (typeof n === 'string' && n.length > 0) {
    return n;
  }
  return '—';
}

function getItemName(item) {
  const hasItem = item !== undefined && item !== null;
  if (hasItem === false) {
    return '—';
  }
  const cfg = item.config !== undefined && item.config !== null ? item.config : null;
  const nameVal = cfg !== null && typeof cfg.name === 'string' ? cfg.name : '';
  return safeName(nameVal);
}

function formatDate(d) {
  if (d === undefined || d === null) {
    return '';
  }
  return new Date(d).toLocaleString();
}

function getPhoneNumber(item) {
  const hasItem = item !== undefined && item !== null;
  if (hasItem === false) {
    return '';
  }
  const cfg = item.config !== undefined && item.config !== null ? item.config : null;
  if (cfg === null) {
    return '';
  }
  const candidates = [cfg.phone, cfg.phoneNumber, cfg.sender, cfg.senderEmail, cfg.emailAddress, cfg.user, cfg.from];
  for (let index = 0; index < candidates.length; index = index + 1) {
    const candidate = typeof candidates[index] === 'string' ? candidates[index] : '';
    if (candidate.length > 0) {
      return candidate;
    }
  }
  return '';
}

function getMetaCustomDomainDisplay(item) {
  if (item === undefined) {
    return '';
  }
  if (item === null) {
    return '';
  }
  if (item.type !== 'whatsappMeta') {
    return '';
  }
  let config = {};
  if (item.config !== undefined) {
    if (item.config !== null) {
      if (typeof item.config === 'object') {
        config = item.config;
      }
    }
  }
  let customNormal = '';
  if (typeof config.customDomain === 'string') {
    customNormal = config.customDomain.trim();
  }
  let customVoice = '';
  if (typeof config.voiceCustomDomain === 'string') {
    customVoice = config.voiceCustomDomain.trim();
  }
  if (customNormal.length > 0) {
    if (customVoice.length > 0) {
      return `${customNormal} / ${customVoice}`;
    }
    return customNormal;
  }
  if (customVoice.length > 0) {
    return customVoice;
  }
  return '';
}

function resolveMainApiMessagesWebhookUrl() {
  if (defaultMessagesWebhookUrl.value.length > 0) {
    return defaultMessagesWebhookUrl.value;
  }
  if (typeof globalState?.apiEndpoint === 'string') {
    const endpoint = globalState.apiEndpoint.replace(/\/+$/, '');
    if (endpoint.length > 0) {
      return `${endpoint}/api/whatsapp/meta/webhook`;
    }
  }
  if (typeof window !== 'undefined') {
    if (window.location !== undefined && window.location !== null) {
      if (typeof window.location.origin === 'string') {
        return `${window.location.origin}/api/whatsapp/meta/webhook`;
      }
    }
  }
  return '';
}

function isPartnerPhone(item) {
  const hasItem = item !== undefined && item !== null;
  if (hasItem === false) {
    return false;
  }
  return item.type === 'phonePartner';
}

function isEmailSource(item) {
  const hasItem = item !== undefined && item !== null;
  if (hasItem === false) {
    return false;
  }
  return item.type === 'emailMicrosoft365' || item.type === 'emailGoogleGmail';
}

function isWhatsappVoiceSource(item) {
  const hasItem = item !== undefined && item !== null;
  if (hasItem === false) {
    return false;
  }
  const config = item.config !== undefined && item.config !== null && typeof item.config === 'object' ? item.config : {};
  return item.type === 'whatsappMeta' && config.voiceEnabled === true;
}

function getEditButtonClass(item) {
  if (isPartnerPhone(item) === true) {
    return lockedButtonClass;
  }
  return editButtonClass;
}

function getDeleteButtonClass(item) {
  if (isPartnerPhone(item) === true) {
    return lockedButtonClass;
  }
  return deleteButtonClass;
}

function getTypeDisplay(type) {
  if (type === 'whatsappMeta') {
    return t('communicationSources.types.whatsappMeta');
  }
  if (type === 'whatsappSmooch') {
    return t('communicationSources.types.whatsappSmooch');
  }
  if (type === 'whatsapp99Digital') {
    return '99';
  }
  if (type === 'twilioPhone') {
    return t('communicationSources.types.twilioPhone');
  }
  if (type === 'phonePartner') {
    return 'Phone (Partner)';
  }
  if (type === 'phoneCustomSip') {
    return 'Phone (Custom SIP)';
  }
  if (type === 'smsTwilio') {
    return 'SMS (Twilio)';
  }
  if (type === 'smsMaskyoo') {
    return 'SMS (Maskyoo)';
  }
  if (type === 'smsQuota') {
    return 'SMS Quota';
  }
  if (type === 'emailMicrosoft365') {
    return 'Email (Outlook)';
  }
  if (type === 'emailGoogleGmail') {
    return 'Email (Gmail)';
  }
  return type;
}

 

function toggleAddDropdown() {
  showAddDropdown.value = showAddDropdown.value === true ? false : true;
}

function chooseType(type) {
  showAddDropdown.value = false;
  isEdit.value = false;
  if (type === 'whatsapp') {
    current.value = { type: 'whatsappMeta', config: { name: '', channel: 'whatsapp', provider: 'meta', customDomain: '', voiceCustomDomain: '' } };
  } else if (type === 'phone') {
    current.value = { type: 'phonePartner', config: { channel: 'phone', provider: 'partner' } };
  } else if (type === 'sms') {
    current.value = { type: 'smsQuota', config: { name: '', channel: 'sms', provider: 'smsQuota' } };
  } else if (type === 'email') {
    current.value = { type: 'emailMicrosoft365', config: { name: '', channel: 'email', provider: 'microsoft365' } };
  } else {
    current.value = { type: 'whatsappMeta', config: { name: '', channel: 'whatsapp', provider: 'meta', customDomain: '', voiceCustomDomain: '' } };
  }
  showModal.value = true;
}

function closeModal() {
  showModal.value = false;
}

async function loadList() {
  loading.value = true;
  try {
    const res = await axios.get(`${globalState.apiEndpoint}/api/communicationSources/list`);
    items.value = Array.isArray(res.data) === true ? res.data.map(it => ({ ...it, phoneDisplay: getPhoneNumber(it) })) : [];
  } finally {
    loading.value = false;
  }
}

async function save() {
  try {
    const isEditMode = isEdit.value === true && current.value.sourceId !== undefined;
    const hasConfig = current.value.config !== undefined && current.value.config !== null;
    const hasName = hasConfig === true && typeof current.value.config.name === 'string' && current.value.config.name.trim().length > 0;
      let nameVal = hasName === true ? current.value.config.name : '';
      if (hasName !== true) {
        if (current.value.type === 'whatsappMeta' || current.value.type === 'whatsapp99Digital') {
          const phoneA = hasConfig === true && typeof current.value.config.phone === 'string' && current.value.config.phone.trim().length > 0 ? current.value.config.phone.trim() : '';
          const phoneB = hasConfig === true && typeof current.value.config.phoneNumber === 'string' && current.value.config.phoneNumber.trim().length > 0 ? current.value.config.phoneNumber.trim() : '';
          const phoneC = hasConfig === true && typeof current.value.config.from === 'string' && current.value.config.from.trim().length > 0 ? current.value.config.from.trim() : '';
          const fallbackName = current.value.type === 'whatsapp99Digital' ? '99' : 'WhatsApp Meta';
          nameVal = phoneA.length > 0 ? phoneA : (phoneB.length > 0 ? phoneB : (phoneC.length > 0 ? phoneC : fallbackName));
        } else if (current.value.type === 'phonePartner') {
          nameVal = 'Phone Partner';
        } else if (current.value.type === 'phoneCustomSip') {
          const phoneA = hasConfig === true && typeof current.value.config.phone === 'string' && current.value.config.phone.trim().length > 0 ? current.value.config.phone.trim() : '';
          nameVal = phoneA.length > 0 ? phoneA : 'Phone Custom SIP';
        } else if (current.value.type === 'smsTwilio') {
          const phoneA = hasConfig === true && typeof current.value.config.phone === 'string' && current.value.config.phone.trim().length > 0 ? current.value.config.phone.trim() : '';
          const phoneB = hasConfig === true && typeof current.value.config.from === 'string' && current.value.config.from.trim().length > 0 ? current.value.config.from.trim() : '';
          nameVal = phoneA.length > 0 ? phoneA : (phoneB.length > 0 ? phoneB : 'SMS Twilio');
        } else if (current.value.type === 'smsMaskyoo') {
          const senderA = hasConfig === true && typeof current.value.config.sender === 'string' && current.value.config.sender.trim().length > 0 ? current.value.config.sender.trim() : '';
          const senderB = hasConfig === true && typeof current.value.config.from === 'string' && current.value.config.from.trim().length > 0 ? current.value.config.from.trim() : '';
          nameVal = senderA.length > 0 ? senderA : (senderB.length > 0 ? senderB : 'SMS Maskyoo');
        } else if (current.value.type === 'smsQuota') {
          nameVal = 'SMS Quota';
        } else if (current.value.type === 'emailMicrosoft365') {
          const emailA = hasConfig === true && typeof current.value.config.senderEmail === 'string' && current.value.config.senderEmail.trim().length > 0 ? current.value.config.senderEmail.trim() : '';
          const emailB = hasConfig === true && typeof current.value.config.user === 'string' && current.value.config.user.trim().length > 0 ? current.value.config.user.trim() : '';
          nameVal = emailA.length > 0 ? emailA : (emailB.length > 0 ? emailB : 'Email Outlook');
        } else if (current.value.type === 'emailGoogleGmail') {
          const emailA = hasConfig === true && typeof current.value.config.senderEmail === 'string' && current.value.config.senderEmail.trim().length > 0 ? current.value.config.senderEmail.trim() : '';
          const emailB = hasConfig === true && typeof current.value.config.emailAddress === 'string' && current.value.config.emailAddress.trim().length > 0 ? current.value.config.emailAddress.trim() : '';
          const emailC = hasConfig === true && typeof current.value.config.user === 'string' && current.value.config.user.trim().length > 0 ? current.value.config.user.trim() : '';
          nameVal = emailA.length > 0 ? emailA : (emailB.length > 0 ? emailB : (emailC.length > 0 ? emailC : 'Email Gmail'));
        } else {
          toast.error(t('communicationSources.toasts.nameRequired'));
          return;
        }
      }
    const orgId = globalState?.userInfo?.organizationID;
    let saveResponse = null;
    if (isEditMode === true) {
      saveResponse = await axios.put(`${globalState.apiEndpoint}/api/communicationSources/modify/${current.value.sourceId}`, { organizationId: orgId, name: nameVal, config: current.value.config });
    } else {
      saveResponse = await axios.post(`${globalState.apiEndpoint}/api/communicationSources/create`, { organizationId: orgId, type: current.value.type, name: nameVal, config: current.value.config });
    }
    showModal.value = false;
    await loadList();
    toast.success(t('communicationSources.toasts.savedSuccess'));
    if (isEditMode === false) {
      if (current.value.type === 'whatsappMeta') {
        if (current.value.config.voiceEnabled === true) {
          let savedSource = null;
          if (saveResponse !== undefined && saveResponse !== null) {
            if (saveResponse.data !== undefined && saveResponse.data !== null) {
              savedSource = saveResponse.data;
            }
          }
          if (savedSource !== null) {
            openWhatsappVoiceSetupModal(savedSource);
          }
        } else {
          postCreateModalTitle.value = 'After saving, set this Webhook Callback URL in Meta Developer Console:';
          postCreateModalHint.value = 'WhatsApp Cloud API webhook callback URL:';
          postCreateWebhook.value = resolveMainApiMessagesWebhookUrl();
          postCreateWebhookWithAgent.value = resolveMainApiMessagesWebhookUrl();
          showPostCreateModal.value = true;
        }
      }
      if (current.value.type === 'twilioPhone') {
        let originStr = '';
        if (typeof window !== 'undefined') {
          if (window.location !== undefined && window.location !== null) {
            if (typeof window.location.origin === 'string') {
              originStr = window.location.origin;
            }
          }
        }
        const base = `${originStr}/api/phone/incoming-call`;
        postCreateModalTitle.value = t('communicationSources.webhooks.twilioNote', 'After saving, set this Voice webhook in Twilio:');
        postCreateModalHint.value = t('communicationSources.webhooks.agentIdHint', 'You can add agentId=[AGENT-ID] if needed:');
        postCreateWebhook.value = base;
        postCreateWebhookWithAgent.value = `${base}?agentId=[AGENT-ID]`;
        showPostCreateModal.value = true;
      }
    }
  } catch (error) {
    let message = t('communicationSources.toasts.failedToSave');
    if (error !== undefined && error !== null) {
      const statusText = typeof error?.response?.status === 'number' ? ` (${error.response.status})` : '';
      const serverMsg = typeof error?.response?.data?.error === 'string' && error.response.data.error.length > 0 ? error.response.data.error : '';
      const serverDetails = typeof error?.response?.data?.details === 'string' && error.response.data.details.length > 0 ? `: ${error.response.data.details}` : '';
      if (serverMsg.length > 0 || serverDetails.length > 0) {
        message = `${serverMsg}${serverDetails}${statusText}`.trim();
      }
    }
    toast.error(message);
  }
}

async function attachDigital99Webhook(payload) {
  try {
    const sourceIdValue = payload !== undefined && payload !== null && payload.sourceId !== undefined && payload.sourceId !== null ? String(payload.sourceId).trim() : '';
    const orgId = globalState?.userInfo?.organizationID;
    if (sourceIdValue.length === 0) {
      toast.error('Missing 99 source id.');
      return;
    }
    const apiEndpoint = typeof globalState?.apiEndpoint === 'string' ? globalState.apiEndpoint.replace(/\/+$/, '') : '';
    await axios.post(`${globalState.apiEndpoint}/api/communicationSources/whatsapp99Digital/${sourceIdValue}/attachWebhook`, {
      organizationId: orgId,
      origin: apiEndpoint
    });
    toast.success('99 webhook attached to AI platform.');
  } catch (error) {
    const serverMsg = typeof error?.response?.data?.error === 'string' ? error.response.data.error : '';
    const serverDetails = typeof error?.response?.data?.details === 'string' ? error.response.data.details : '';
    const message = serverMsg.length > 0 ? serverMsg : (serverDetails.length > 0 ? serverDetails : 'Failed to attach 99 webhook.');
    toast.error(message);
  }
}

async function edit(itemOrSourceId) {
  const item = itemOrSourceId !== undefined && itemOrSourceId !== null && typeof itemOrSourceId === 'object' ? itemOrSourceId : null;
  if (isPartnerPhone(item) === true) {
    return;
  }
  const sourceId = typeof itemOrSourceId === 'string' ? itemOrSourceId : itemOrSourceId?.sourceId;
  const res = await axios.get(`${globalState.apiEndpoint}/api/communicationSources/${sourceId}`);
  current.value = res.data;
  isEdit.value = true;
  showModal.value = true;
}

function requestRemove(itemOrSourceId) {
  const item = itemOrSourceId !== undefined && itemOrSourceId !== null && typeof itemOrSourceId === 'object' ? itemOrSourceId : null;
  if (isPartnerPhone(item) === true) {
    return;
  }
  pendingDeleteItem.value = itemOrSourceId;
  showDeleteConfirmModal.value = true;
}

function closeDeleteConfirmModal() {
  showDeleteConfirmModal.value = false;
  pendingDeleteItem.value = null;
  deleteInProgress.value = false;
}

function createDefaultTestEmailForm(addresses = '') {
  return {
    title: 'Test Email',
    body: 'This is a test email.',
    addresses
  };
}

function getDefaultTestAddresses(item) {
  const candidate = getPhoneNumber(item);
  if (candidate.includes('@') === true) {
    return candidate;
  }
  return '';
}

function openTestEmailModal(item) {
  if (isEmailSource(item) !== true) {
    return;
  }
  testEmailSource.value = item;
  testEmailForm.value = createDefaultTestEmailForm(getDefaultTestAddresses(item));
  sendingTestEmail.value = false;
  showTestEmailModal.value = true;
}

function closeTestEmailModal() {
  showTestEmailModal.value = false;
  sendingTestEmail.value = false;
  testEmailSource.value = null;
  testEmailForm.value = createDefaultTestEmailForm();
}

function createDefaultWhatsappVoicePermissionForm() {
  return {
    recipient: '',
    message: 'We would like to call you to help with your request. Please allow us to call you on WhatsApp.'
  };
}

function normalizeE164(value) {
  const digits = typeof value === 'string' ? value.replace(/\D/g, '') : '';
  if (digits.length < 7 || digits.length > 15 || digits.startsWith('0') === true) {
    return '';
  }
  return `+${digits}`;
}

const defaultVoiceWebhookUrl = ref('');
const defaultVoiceServiceUrl = ref('');
const defaultMessagesWebhookUrl = ref('');

async function loadWebhookDefaults() {
  try {
    const res = await axios.get(`${globalState.apiEndpoint}/api/communicationSources/whatsappMeta/webhookDefaults`);
    if (res.data !== undefined && res.data !== null) {
      if (typeof res.data.voiceServiceUrl === 'string') {
        defaultVoiceServiceUrl.value = res.data.voiceServiceUrl;
      }
      if (typeof res.data.voiceWebhookUrl === 'string') {
        defaultVoiceWebhookUrl.value = res.data.voiceWebhookUrl;
      }
      if (typeof res.data.messagesWebhookUrl === 'string') {
        defaultMessagesWebhookUrl.value = res.data.messagesWebhookUrl;
      }
    }
  } catch (error) {}
}

function resolveMainApiVoiceWebhookUrl() {
  if (defaultVoiceWebhookUrl.value.length > 0) {
    return defaultVoiceWebhookUrl.value;
  }
  let baseOrigin = '';
  if (typeof globalState?.apiEndpoint === 'string') {
    const endpoint = globalState.apiEndpoint.replace(/\/+$/, '');
    if (endpoint.length > 0) {
      baseOrigin = endpoint;
    }
  }
  if (baseOrigin.includes('preprod.sonarix.ai') === true) {
    return 'https://voice.preprod.sonarix.ai/whatsappVoice/webhook';
  }
  if (baseOrigin.includes('sonarix.ai') === true) {
    return `${baseOrigin.replace('api.', 'voice.').replace('app.', 'voice.')}/whatsappVoice/webhook`;
  }
  if (baseOrigin.length === 0) {
    if (typeof window !== 'undefined') {
      if (window.location !== undefined && window.location !== null) {
        if (typeof window.location.origin === 'string') {
          baseOrigin = window.location.origin;
        }
      }
    }
  }
  return `${baseOrigin}/whatsappVoice/webhook`;
}

function resolveMainApiVoiceServiceUrl() {
  if (defaultVoiceServiceUrl.value.length > 0) {
    return defaultVoiceServiceUrl.value;
  }
  return resolveMainApiVoiceWebhookUrl().replace(/\/whatsappVoice\/webhook$/, '');
}

function getWabaId(item) {
  if (item === undefined) {
    return '—';
  }
  if (item === null) {
    return '—';
  }
  let config = {};
  if (item.config !== undefined) {
    if (item.config !== null) {
      if (typeof item.config === 'object') {
        config = item.config;
      }
    }
  }
  if (typeof config.wabaId === 'string') {
    if (config.wabaId.length > 0) {
      return config.wabaId;
    }
  }
  return '—';
}

function getPhoneNumberId(item) {
  if (item === undefined) {
    return '—';
  }
  if (item === null) {
    return '—';
  }
  let config = {};
  if (item.config !== undefined) {
    if (item.config !== null) {
      if (typeof item.config === 'object') {
        config = item.config;
      }
    }
  }
  if (typeof config.phoneNumberId === 'string') {
    if (config.phoneNumberId.length > 0) {
      return config.phoneNumberId;
    }
  }
  return '—';
}

function openWhatsappVoiceSetupModal(item) {
  if (isWhatsappVoiceSource(item) !== true) {
    return;
  }
  whatsappVoiceSetupSource.value = item;
  whatsappVoiceSetupActiveStep.value = 1;
  whatsappVoiceSetupAppSubscribed.value = false;
  whatsappVoiceSetupWebhookSubscribed.value = false;
  whatsappVoiceSetupCallingSaved.value = false;
  whatsappVoiceSetupPermissionSent.value = false;
  whatsappVoiceSetupPermissionMessageId.value = '';
  whatsappVoiceSetupServiceUrl.value = resolveMainApiVoiceServiceUrl();
  whatsappVoiceSetupCallbackUrl.value = resolveMainApiVoiceWebhookUrl();
  let config = {};
  if (item !== undefined && item !== null) {
    if (item.config !== undefined && item.config !== null && typeof item.config === 'object') {
      config = item.config;
    }
  }
  let iconVisibility = 'default';
  if (typeof config.voiceCallIconVisibility === 'string') {
    if (config.voiceCallIconVisibility === 'DISABLE_ALL' || config.voiceCallIconVisibility === 'disableAll') {
      iconVisibility = 'disableAll';
    }
  }
  whatsappVoiceSetupCallingForm.value = {
    voiceCallIconVisibility: iconVisibility,
    voiceCallbackPermissionEnabled: config.voiceCallbackPermissionEnabled !== false
  };
  whatsappVoiceSetupPermissionForm.value = {
    recipient: '',
    message: 'We would like to call you to help with your request. Please allow us to call you on WhatsApp.'
  };
  const defaultLang = resolveDefaultCallPermissionLanguage();
  whatsappVoiceSetupTemplateLanguage.value = defaultLang;
  const langPreset = callPermissionLanguagePresets[defaultLang];
  if (langPreset !== undefined) {
    if (langPreset !== null) {
      whatsappVoiceSetupTemplateName.value = langPreset.name;
      whatsappVoiceSetupTemplateBody.value = langPreset.body;
    }
  }
  whatsappVoiceSetupCreatingTemplate.value = false;
  whatsappVoiceSetupTemplateCreated.value = false;
  showWhatsappVoiceSetupModal.value = true;
}

async function copyWhatsappVoiceWebhook() {
  await navigator.clipboard.writeText(whatsappVoiceSetupCallbackUrl.value);
  toast.success('Webhook URL copied.');
}

function closeWhatsappVoiceSetupModal() {
  showWhatsappVoiceSetupModal.value = false;
  whatsappVoiceSetupSource.value = null;
}

function openWhatsappVoicePermissionModal(item) {
  openWhatsappVoiceSetupModal(item);
}

function closeWhatsappVoicePermissionModal() {
  closeWhatsappVoiceSetupModal();
}

async function subscribeWhatsappVoiceApp() {
  const source = whatsappVoiceSetupSource.value;
  let sourceId = 0;
  if (source !== undefined && source !== null) {
    sourceId = Number(source.sourceId);
  }
  console.log('[whatsappVoiceSetup] subscribeWhatsappVoiceApp started', {
    sourceId,
    source,
    timestamp: new Date().toISOString()
  });
  if (Number.isFinite(sourceId) !== true) {
    console.error('[whatsappVoiceSetup] Invalid sourceId', { sourceId });
    toast.error('Missing WhatsApp source ID.');
    return;
  }
  if (sourceId <= 0) {
    console.error('[whatsappVoiceSetup] sourceId <= 0', { sourceId });
    toast.error('Missing WhatsApp source ID.');
    return;
  }
  whatsappVoiceSetupSubscribingApp.value = true;
  const startTs = Date.now();
  try {
    console.log('[whatsappVoiceSetup] Sending POST to /metaAppSubscription...', { sourceId });
    const res = await axios.post(`${globalState.apiEndpoint}/api/communicationSources/whatsappMeta/${sourceId}/metaAppSubscription`);
    const durationMs = Date.now() - startTs;
    console.log('[whatsappVoiceSetup] POST /metaAppSubscription response', {
      sourceId,
      durationMs,
      data: res.data
    });
    whatsappVoiceSetupAppSubscribed.value = true;
    toast.success('Meta app subscribed to WABA successfully.');
  } catch (error) {
    const durationMs = Date.now() - startTs;
    console.error('[whatsappVoiceSetup] POST /metaAppSubscription failed', {
      sourceId,
      durationMs,
      status: error?.response?.status,
      errorData: error?.response?.data
    });
    let msg = 'Failed to subscribe Meta app to WABA.';
    if (typeof error?.response?.data?.error === 'string') {
      msg = error.response.data.error;
    }
    toast.error(msg);
  } finally {
    whatsappVoiceSetupSubscribingApp.value = false;
  }
}

async function subscribeWhatsappVoiceWebhook() {
  const source = whatsappVoiceSetupSource.value;
  let sourceId = 0;
  if (source !== undefined && source !== null) {
    sourceId = Number(source.sourceId);
  }
  console.log('[whatsappVoiceSetup] subscribeWhatsappVoiceWebhook started', {
    sourceId,
    callbackUrl: whatsappVoiceSetupCallbackUrl.value,
    timestamp: new Date().toISOString()
  });
  if (Number.isFinite(sourceId) !== true) {
    console.error('[whatsappVoiceSetup] Invalid sourceId', { sourceId });
    toast.error('Missing WhatsApp source ID.');
    return;
  }
  if (sourceId <= 0) {
    console.error('[whatsappVoiceSetup] sourceId <= 0', { sourceId });
    toast.error('Missing WhatsApp source ID.');
    return;
  }
  const callbackUrl = whatsappVoiceSetupCallbackUrl.value.trim();
  if (callbackUrl.length === 0) {
    console.error('[whatsappVoiceSetup] callbackUrl is empty');
    toast.error('Callback URL is required.');
    return;
  }
  whatsappVoiceSetupSubscribingWebhook.value = true;
  const startTs = Date.now();
  try {
    console.log('[whatsappVoiceSetup] Sending POST to /metaWebhookSubscription...', {
      sourceId,
      callbackUrl
    });
    const res = await axios.post(`${globalState.apiEndpoint}/api/communicationSources/whatsappMeta/${sourceId}/metaWebhookSubscription`, {
      callbackUrl
    });
    const durationMs = Date.now() - startTs;
    console.log('[whatsappVoiceSetup] POST /metaWebhookSubscription response', {
      sourceId,
      callbackUrl,
      durationMs,
      data: res.data
    });
    whatsappVoiceSetupWebhookSubscribed.value = true;
    toast.success('Meta WABA webhook callback subscribed.');
  } catch (error) {
    const durationMs = Date.now() - startTs;
    console.error('[whatsappVoiceSetup] POST /metaWebhookSubscription failed', {
      sourceId,
      callbackUrl,
      durationMs,
      status: error?.response?.status,
      errorData: error?.response?.data
    });
    let msg = 'Failed to configure Meta WABA webhook callback.';
    if (typeof error?.response?.data?.error === 'string') {
      msg = error.response.data.error;
    }
    toast.error(msg);
  } finally {
    whatsappVoiceSetupSubscribingWebhook.value = false;
  }
}

async function saveWhatsappVoiceCallingSettings() {
  const source = whatsappVoiceSetupSource.value;
  let sourceId = 0;
  if (source !== undefined && source !== null) {
    sourceId = Number(source.sourceId);
  }
  console.log('[whatsappVoiceSetup] saveWhatsappVoiceCallingSettings started', {
    sourceId,
    callingForm: whatsappVoiceSetupCallingForm.value,
    timestamp: new Date().toISOString()
  });
  if (Number.isFinite(sourceId) !== true) {
    console.error('[whatsappVoiceSetup] Invalid sourceId', { sourceId });
    toast.error('Missing WhatsApp source ID.');
    return;
  }
  if (sourceId <= 0) {
    console.error('[whatsappVoiceSetup] sourceId <= 0', { sourceId });
    toast.error('Missing WhatsApp source ID.');
    return;
  }
  whatsappVoiceSetupSavingCalling.value = true;
  const startTs = Date.now();
  try {
    const payload = {
      voiceEnabled: true,
      voiceCallIconVisibility: whatsappVoiceSetupCallingForm.value.voiceCallIconVisibility,
      voiceCallbackPermissionEnabled: whatsappVoiceSetupCallingForm.value.voiceCallbackPermissionEnabled === true
    };
    console.log('[whatsappVoiceSetup] Sending PUT to /calling...', { sourceId, payload });
    const res = await axios.put(`${globalState.apiEndpoint}/api/communicationSources/whatsappMeta/${sourceId}/calling`, payload);
    const durationMs = Date.now() - startTs;
    console.log('[whatsappVoiceSetup] PUT /calling response', {
      sourceId,
      durationMs,
      data: res.data
    });
    whatsappVoiceSetupCallingSaved.value = true;
    toast.success('Meta Calling API settings applied successfully.');
  } catch (error) {
    const durationMs = Date.now() - startTs;
    console.error('[whatsappVoiceSetup] PUT /calling failed', {
      sourceId,
      durationMs,
      status: error?.response?.status,
      errorData: error?.response?.data
    });
    let msg = 'Failed to apply Meta Calling settings.';
    if (typeof error?.response?.data?.error === 'string') {
      msg = error.response.data.error;
    }
    toast.error(msg);
  } finally {
    whatsappVoiceSetupSavingCalling.value = false;
  }
}

async function sendWhatsappVoicePermissionRequest() {
  const source = whatsappVoiceSetupSource.value;
  let sourceId = 0;
  if (source !== undefined && source !== null) {
    sourceId = Number(source.sourceId);
  }
  console.log('[whatsappVoiceSetup] sendWhatsappVoicePermissionRequest started', {
    sourceId,
    permissionForm: whatsappVoiceSetupPermissionForm.value,
    timestamp: new Date().toISOString()
  });
  if (Number.isFinite(sourceId) !== true) {
    console.error('[whatsappVoiceSetup] Invalid sourceId', { sourceId });
    toast.error('Missing WhatsApp source ID.');
    return;
  }
  if (sourceId <= 0) {
    console.error('[whatsappVoiceSetup] sourceId <= 0', { sourceId });
    toast.error('Missing WhatsApp source ID.');
    return;
  }
  const recipient = normalizeE164(whatsappVoiceSetupPermissionForm.value.recipient);
  const message = whatsappVoiceSetupPermissionForm.value.message.trim();
  if (recipient.length === 0) {
    console.error('[whatsappVoiceSetup] Recipient format invalid', {
      rawRecipient: whatsappVoiceSetupPermissionForm.value.recipient
    });
    toast.error('Please enter a valid WhatsApp phone number in E.164 format (e.g. +14155550132).');
    return;
  }
  if (message.length === 0) {
    console.error('[whatsappVoiceSetup] Message is empty');
    toast.error('Please enter a reason message.');
    return;
  }
  whatsappVoiceSetupSendingPermission.value = true;
  const startTs = Date.now();
  try {
    console.log('[whatsappVoiceSetup] Sending POST to /callPermissionRequests...', {
      sourceId,
      recipient,
      messageLength: message.length
    });
    const res = await axios.post(`${globalState.apiEndpoint}/api/communicationSources/whatsappMeta/${sourceId}/callPermissionRequests`, {
      recipient,
      message
    });
    const durationMs = Date.now() - startTs;
    console.log('[whatsappVoiceSetup] POST /callPermissionRequests response', {
      sourceId,
      recipient,
      durationMs,
      data: res.data
    });
    if (typeof res?.data?.messageId === 'string') {
      whatsappVoiceSetupPermissionMessageId.value = res.data.messageId;
    }
    whatsappVoiceSetupPermissionSent.value = true;
    toast.success('WhatsApp call permission request sent to contact.');
  } catch (error) {
    const durationMs = Date.now() - startTs;
    console.error('[whatsappVoiceSetup] POST /callPermissionRequests failed', {
      sourceId,
      recipient,
      durationMs,
      status: error?.response?.status,
      errorData: error?.response?.data
    });
    let msg = 'Failed to send WhatsApp call permission request.';
    if (typeof error?.response?.data?.error === 'string') {
      msg = error.response.data.error;
    }
    toast.error(msg);
  } finally {
    whatsappVoiceSetupSendingPermission.value = false;
  }
}

function sendWhatsappVoicePermission() {
  sendWhatsappVoicePermissionRequest();
}

async function confirmRemove() {
  const raw = pendingDeleteItem.value;
  if (raw === undefined || raw === null) {
    return;
  }
  const item = typeof raw === 'object' ? raw : null;
  if (isPartnerPhone(item) === true) {
    closeDeleteConfirmModal();
    return;
  }
  const sourceId = typeof raw === 'string' ? raw : raw.sourceId;
  if (sourceId === undefined || sourceId === null || String(sourceId).length === 0) {
    closeDeleteConfirmModal();
    return;
  }
  deleteInProgress.value = true;
  try {
    await axios.delete(`${globalState.apiEndpoint}/api/communicationSources/delete/${sourceId}`);
    await loadList();
    closeDeleteConfirmModal();
  } catch (error) {
    deleteInProgress.value = false;
    let message = t('communicationSources.toasts.deleteFailed');
    if (error !== undefined && error !== null) {
      const statusText = typeof error?.response?.status === 'number' ? ` (${error.response.status})` : '';
      const serverMsg = typeof error?.response?.data?.error === 'string' && error.response.data.error.length > 0 ? error.response.data.error : '';
      if (serverMsg.length > 0) {
        message = `${serverMsg}${statusText}`.trim();
      }
    }
    toast.error(message);
  }
}

async function sendTestEmail() {
  if (canSendTestEmail.value !== true) {
    return;
  }
  const source = testEmailSource.value;
  if (source === undefined || source === null) {
    return;
  }
  sendingTestEmail.value = true;
  try {
    await axios.post(`${globalState.apiEndpoint}/api/communicationSources/testEmail/${source.sourceId}`, {
      title: testEmailForm.value.title,
      body: testEmailForm.value.body,
      addresses: testEmailForm.value.addresses
    });
    toast.success('Test email sent successfully.');
    closeTestEmailModal();
  } catch (error) {
    sendingTestEmail.value = false;
    let message = 'Failed to send test email.';
    if (error !== undefined && error !== null) {
      const statusText = typeof error?.response?.status === 'number' ? ` (${error.response.status})` : '';
      const serverMsg = typeof error?.response?.data?.error === 'string' && error.response.data.error.length > 0 ? error.response.data.error : '';
      const serverDetails = typeof error?.response?.data?.details === 'string' && error.response.data.details.length > 0 ? `: ${error.response.data.details}` : '';
      if (serverMsg.length > 0 || serverDetails.length > 0) {
        message = `${serverMsg}${serverDetails}${statusText}`.trim();
      }
    }
    toast.error(message);
  }
}

onMounted(() => {
  loadList();
  loadWebhookDefaults();
});

async function onModalSave(form) {
  try {
    const hasFormObject = form !== undefined && form !== null && typeof form === 'object';
    if (hasFormObject === true && typeof form.type === 'string' && form.type.length > 0) {
      const nextConfig = form.config !== undefined && form.config !== null && typeof form.config === 'object' ? form.config : {};
      current.value.type = form.type;
      current.value.config = { ...nextConfig };
    } else {
      current.value.config = { ...form };
    }
    await save();
  } catch (error) {
    
  }
}

function copyToClipboard(text) {
  try {
    if (navigator !== undefined && navigator !== null && navigator.clipboard !== undefined && navigator.clipboard !== null && navigator.clipboard.writeText !== undefined) {
      navigator.clipboard.writeText(text);
      return;
    }
  } catch (e) {}
  const ta = document.createElement('textarea');
  ta.value = text;
  document.body.appendChild(ta);
  ta.select();
  try { document.execCommand('copy') } catch (e) {}
  document.body.removeChild(ta);
}

function handlePostCopy(key, text) {
  copyToClipboard(text);
  copiedPostKey.value = String(key);
  window.setTimeout(() => { if (copiedPostKey.value === key) { copiedPostKey.value = '' } }, 1200);
}

function toLtr(text) {
  return "\u2066" + String(text) + "\u2069";
}
</script>

<style>
.vue3-easy-data-table { height: 95%; }
.icons-row > svg { margin-right: 0.5rem; }
html[dir="rtl"] .icons-row > svg { margin-left: 0.5rem; margin-right: 0; }
.force-ltr { direction: ltr; unicode-bidi: isolate; }
.action-btn-disabled { opacity: 0.5; cursor: not-allowed; pointer-events: none; }
.numbered-actions { margin-bottom: 16px; }
.numbered-action-item {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid rgba(156, 163, 175, 0.4);
  border-radius: 10px;
  margin-bottom: 8px;
  text-align: left;
  background: transparent;
  cursor: pointer;
  transition: all 160ms ease;
}
.numbered-action-item:hover {
  background: rgba(34, 197, 94, 0.08);
}
.numbered-action-item.active-step {
  border-color: #22c55e;
  background: rgba(34, 197, 94, 0.12);
}
.numbered-action-item.ready-step .numbered-action-badge {
  background: rgba(34, 197, 94, 0.2);
  color: #16a34a;
}
.numbered-action-badge {
  width: 28px;
  height: 28px;
  min-width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(156, 163, 175, 0.2);
  color: #4b5563;
  font-weight: 700;
  font-size: 12px;
  margin-right: 10px;
}
.numbered-action-text {
  flex: 1;
  overflow: hidden;
}
.numbered-action-text strong {
  display: block;
  font-size: 12px;
  line-height: 1.2;
}
.numbered-action-text small {
  display: block;
  font-size: 10px;
  color: #6b7280;
  margin-top: 2px;
}
.setup-checklist-box {
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 8px;
  background: rgba(156, 163, 175, 0.1);
}
.setup-checklist-step {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 1.4;
}
.setup-step-num {
  width: 20px;
  height: 20px;
  min-width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(34, 197, 94, 0.15);
  color: #16a34a;
  font-weight: 700;
  font-size: 11px;
  margin-right: 8px;
  margin-top: 1px;
}
</style>


